import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AgeCalculator from "./components/AgeCalculator";
import BMICalculator from "./components/BMICalculator";
import LoanCalculator from "./components/LoanCalculator";
import TipCalculator from "./components/TipCalculator";
import CurrencyConverter from "./components/CurrencyConverter";
import DaysBetweenDates from "./components/DaysBetweenDates";
import PercentageCalculator from "./components/PercentageCalculator";
import DiscountCalculator from "./components/DiscountCalculator";
import CompoundInterestCalculator from "./components/CompoundInterestCalculator";
import UnitConverter from "./components/UnitConverter";
import ZakatCalculator from "./components/ZakatCalculator";
import IncomeTaxCalculatorPk from "./components/IncomeTaxCalculatorPk";
import "./App.css";

// Resets scroll to the top whenever the route changes. Without this, a
// client-side navigation keeps the previous page's scroll position, so
// opening a calculator from a scrolled-down home page lands mid-page.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/age" element={<AgeCalculator />} />
        <Route path="/bmi" element={<BMICalculator />} />
        <Route path="/loan" element={<LoanCalculator />} />
        <Route path="/tip" element={<TipCalculator />} />
        <Route path="/currency" element={<CurrencyConverter />} />
        <Route path="/days-between" element={<DaysBetweenDates />} />
        <Route path="/percentage" element={<PercentageCalculator />} />
        <Route path="/discount" element={<DiscountCalculator />} />
        <Route path="/compound-interest" element={<CompoundInterestCalculator />} />
        <Route path="/unit-converter" element={<UnitConverter />} />
        <Route path="/zakat" element={<ZakatCalculator />} />
        <Route path="/pakistan-income-tax" element={<IncomeTaxCalculatorPk />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
